let clientX = -100;
let clientY = -100;
const innerCursor = document.querySelector('.cursor');


export function initHovers() {

  const handleMouseEnter = e => {
    innerCursor.classList.add('hover');
  };
  
  const handleMouseLeave = () => {
    innerCursor.classList.remove('hover');
  };

  const handleMouseEnterCase = e => {
    innerCursor.classList.add('hover-case');
  };
  
  const handleMouseLeaveCase = () => {
    innerCursor.classList.remove('hover-case');
  };
  
  // add event listeners to all items
  var linkItems = document.querySelectorAll('.link');
  var linkCases = document.querySelectorAll('.link-case');

  linkItems.forEach(item => {
    item.addEventListener("mouseover", handleMouseEnter);
    item.addEventListener("mouseout", handleMouseLeave);
  });
  linkCases.forEach(item => {
    item.addEventListener("mouseover", handleMouseEnterCase);
    item.addEventListener("mouseout", handleMouseLeaveCase);
  });
  
};

export function initCursor() {

  document.addEventListener("mousemove", e => {
    clientX = e.clientX;
    clientY = e.clientY;
  });
  
  const render = () => {
    innerCursor.style.transform = `translate(${clientX}px, ${clientY}px)`;
    
    requestAnimationFrame(render);
  };

  requestAnimationFrame(render);
}